import { Button, Spinner } from "react-bootstrap";
import './UserForgotPassword.scss'
import { useEffect, useState } from "react";
import { handleSubmitVerifyForgotPwd } from '../../services/accountServices'
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import _ from "lodash";
import { handleSubmitVerifyCodeForgotPwd } from '../../services/accountServices'
import { useNavigate } from "react-router-dom/dist";


const ForgetPwd = () => {


  const validInputDefault = {
    password: true,
    repassword: true,
  }


  const defaultUserData = {
    password: '', //dataModalUserUpdate.password,
    repassword: ''
  }

  const [userCode, setUserCode] = useState("");
  const navigate = useNavigate()
  const [showConfirm, setShowConfirm] = useState(false);
  const [showNotifyPasswordChanged, setShowNotifyPasswordChanged] = useState(false)
  const [emailUser, setEmailUser] = useState("")
  const [validInputEmail, setValidInputEmail] = useState(true)
  const [verifyInput, setVerifyInput] = useState("")
  const [showRePassword, setShowRePassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [userData, setUserData] = useState(defaultUserData)
  const [validInput, setValidInput] = useState(validInputDefault)
  const [verifyCodeFromEmail, setVerifyCodeFromEmail] = useState("")
  const [password, setPassword] = useState("")
  const [repassword, setRePassword] = useState("")
  const [validInputPassword, setValidInputPassword] = useState(true)
  const [validInputRePassword, setValidInputRePassword] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [timeLeft, setTimeLeft] = useState(120);
  const [isResend, setIsReSend] = useState(false)
  const [disabled, setIsDisabled] = useState(true)
  // const [validInputUserCode, setValidInputUserCode] = useState(true)


  const isValidEmail = (email) => {


    let regexEmail = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]{5,16}@gmail\.com$/

    if (regexEmail.test(email) === false) {
      setValidInputEmail(false)
    } else {
      setValidInputEmail(true)
    }
  }

  const isValidPassword = (password) => {
    let regexPwd = /^[\s\S]{7,16}$/
    if (regexPwd.test(password) === false) {
      setValidInputPassword(false)
    } else {
      setValidInputPassword(true)
    }
  }

  const isValidRePassword = (repassword) => {
    if (repassword !== password) {
      setValidInputRePassword(false)
    } else {
      setValidInputRePassword(true)
    }
  }

  const isValidValue = () => {
    if (validInputPassword === "" && validInputRePassword === "")
      return false
    return validInputPassword && validInputRePassword
  }

  // const isValidUserCode = (userCode) => {
  //   let regexUserCode = /^[a-zA-Z0-9]{8}$/
  //   if (regexUserCode.test(userCode) === false) {
  //     setValidInputUserCode(false)
  //   } else {
  //     setValidInputUserCode(true)
  //   }
  // }

  const handleSendConfirmVerify = async () => {
    // alert(`me is ${emailUser} and ${userCode}`)
    setIsLoading(true)
    let response = await handleSubmitVerifyForgotPwd({ emailUser })
    if (response && response.ok) {
      toast.success(response.message)
      // console.log('responde.data', response.data);
      setUserCode(response.data)
      setVerifyCodeFromEmail(response.data)
      setShowConfirm(true)
      setIsLoading(false)
      setTimeLeft(120);  // Reset lại thời gian khi gửi mã mới
      setIsReSend(false);  // Ẩn nút gửi lại
    } else {
      toast.error(response.message)
      setIsLoading(false)
    }
  }

  const handleResendComfirmVerify = async () => {
    setIsReSend(false)
    let response = await handleSubmitVerifyForgotPwd({ emailUser })
    if (response && response.ok) {
      toast.success(response.message)
      // console.log('responde.data', response.data);
      setVerifyCodeFromEmail(response.data)
      setTimeLeft(120);  // Reset lại thời gian khi gửi mã mới
      setIsReSend(false);  // Ẩn nút gửi lại
    } else {
      toast.error(response.message)
      toast.error('Có lỗi, vui lòng thử lại')
      setShowConfirm(false)
    }
  }

  const handleSubmitVerify = async () => {
    //alert(`verrify is ${verifyInput}`)
    let response = await handleSubmitVerifyCodeForgotPwd({ verifyInput, emailUser })
    if (response && response.ok) {
      toast.success(response.message)
      setShowNotifyPasswordChanged(true)
      setShowConfirm(false)
    } else {
      toast.error(response.message)
    }
    // if (true) {
    //   setShowConfirm(false);
    //   setShowNotifyPasswordChanged(true)
    // }
  }

  const handleSubmitChangePassword = async () => {
    alert(`me me me: ${password}, ${repassword}, ${userCode}`)

  }

  const hideEmail = (email) => {
    let [localPart, domain] = email.split('@');
    let hiddenLocalPart = "****" + localPart.slice(-3);
    return hiddenLocalPart + "@" + domain;
  }

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRePasswordVisibility = () => {
    setShowRePassword(!showRePassword);
  };


  useEffect(() => {
    let timer;
    if (showConfirm && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsReSend(true);
    }

    return () => clearInterval(timer); // Dọn dẹp bộ đếm thời gian
  }, [timeLeft, showConfirm]);





  return (
    <>
      <div className="bodyd">
        <div className="cardo">
          <p className="lock-icon" style={{ color: "white" }}><i class="fa fa-lock"></i></p>
          <h2 className="h2">Quên mật khẩu?</h2>
          <p className="p">Hãy điền đầy đủ các thông tin sau</p>
          {/* <input
            type="text"
            className="passInput mt-3 mb-3"
            placeholder="Nhập mã người dùng của bạn"
            onChange={(e) => { setUserCode(e.target.value); isValidUserCode(e.target.value) }}
          />
          {validInputUserCode === false ? <span className="err">Hãy nhập mã người dùng hợp lệ</span> : <></>} */}
          <input
            type="email"
            className="passInput mt-3 mb-3"
            placeholder="Nhập email của bạn"
            onChange={(e) => { setEmailUser(e.target.value); isValidEmail(e.target.value) }}
          />
          {validInputEmail === false ? <span className="err">Hãy nhập email hợp lệ</span> : <></>}
          <Button className="button mb-3" onClick={handleSendConfirmVerify} disabled={isLoading}>{isLoading ? (<>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            /></>) : 'Xác minh'}</Button>
          <Button
            variant="link"
            onClick={() => { navigate('/login') }}
            style={{ fontSize: '14px' }}
            className="link"
          >
            Quay lại trang đăng nhập
          </Button>
        </div>
      </div>

      <Modal show={showConfirm} onHide={() => { setShowConfirm(false); }}>
        <Modal.Header closeButton>
          <Modal.Title>Yêu cầu xác thực</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Chúng tôi đã gửi một mã xác thực tới {hideEmail(emailUser)}.</p>
          <p>Hãy nhập mã xác thực vào ô bên dưới</p>
          <input
            type="text"
            className="passInput mt-3 mb-3 text-dark"
            placeholder="Nhập mã xác thực ở đây"
            onChange={(e) => { setVerifyInput(e.target.value) }}
          />
        </Modal.Body>

        <Modal.Footer>
          <p>Mã xác thực sẽ hết hạn sau <strong>{timeLeft} giây</strong></p>
          {isResend && (
            <Button variant="secondary" onClick={handleResendComfirmVerify}>
              Gửi lại mã xác thực
            </Button>
          )}
          <Button variant="primary" onClick={handleSubmitVerify}>Xác minh</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNotifyPasswordChanged} onHide={() => { setShowNotifyPasswordChanged(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Xác minh thành công</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className='col-12 form-group'>
            <label>Mật khẩu mới: </label>
            <div className='d-flex'>
              <input className={validInputPassword === true ? 'form-control' : 'form-control is-invalid'} type={showPassword ? 'text' : 'password'} onChange={(event) => { setPassword(event.target.value); isValidPassword(event.target.value) }}></input>
              {validInputPassword === false ? <span className="err">Mật khẩu từ 7 - 16 ký tự</span> : <></>}
              <Button
                className="password-toggle-btn"
                onClick={togglePasswordVisibility}
                style={{ marginLeft: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderStyle: "solid" }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </div>

          </div>
          <div className='col-12 form-group'>
            <label>Nhập lại mật khẩu mới: </label>
            <div className='d-flex'>
              <input className={validInputRePassword === true ? 'form-control' : 'form-control is-invalid'} type={showRePassword ? 'text' : 'password'} onChange={(event) => { setRePassword(event.target.value); isValidRePassword(event.target.value) }}></input>
              {validInputRePassword === false ? <span className="err">Mật khẩu không khớp.</span> : <></>}
              <Button
                className="password-toggle-btn"
                onClick={toggleRePasswordVisibility}
                style={{ marginLeft: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', borderStyle: "solid" }}
              >
                {showRePassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" disabled={!isValidValue()} onClick={handleSubmitChangePassword}>Xác minh</Button>
        </Modal.Footer>
      </Modal>

    </>
  );
};

export default ForgetPwd;
